//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'

export default {
  name:'FluidRepletionAfterBurns',
  data() {
    return {
      defaultJson:{
        "Weight": "体重",
        "↳": "↳",
        "Burned TBSA": "烧伤体表面积",
        "Replacement fluid for the first 24 hours in addition to maintenance fluid.": "除生理需求外首个 24 小时所需补液量",
        "Fluid Given This Far": "目前补液量",
        "Next 16 hr": "随后 16 小时",
        "First {{first}}": "首个 {{first}}",
        "Time Since Burn": "烧伤时间"
      },
      form:{
        weight:'',
        surface:'',
        time:'0',
        given:'0',
      },
      hasScore:false,
      disabled:false,
      dataList:[
        {value:"1",name:'放松',shortName:'放松'},
        {value:"2",name:'部分紧张（如眉弓压低）',shortName:'部分紧张'},
        {value:"3",name:'完全紧张（如眼睑紧闭）',shortName:'完全紧张'},
        {value:"4",name:'僵硬',shortName:'僵硬'},
      ],
      dataList2:[
        {value:"1",name:'没有活动"',shortName:'没有活动"'},
        {value:"2",name:'轻度屈曲',shortName:'轻度屈曲'},
        {value:"3",name:'完全屈曲伴手指弯曲',shortName:'完全屈曲'},
        {value:"4",name:'永久性回缩',shortName:'永久性回缩'},
      ],
      dataList3:[
        {value:"1",name:'耐受',shortName:'耐受'},
        {value:"2",name:'咳嗽但大多数时间可耐受',shortName:'咳嗽'},
        {value:"3",name:'对抗呼吸机',shortName:'对抗'},
        {value:"4",name:'无法控制通气',shortName:'无法控制'},
      ],
      half:'',
      first:'',
      start:'',
      start_hr:'',
      then:'',
      then_hr:''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    
    maxNSum(num, obj ){
      let self = this
      

    },

  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        // facial + limb + ventilation + resp
        self.half= 4 * form.weight * form.surface / 2
        self.first= 8 - form.time
        self.start = (self.first ? ((self.half > form.given) ? (self.half - form.given) : 0) : self.first).toFixed(0)
        self.start_hr = ((self.start > 0) ? (self.start / self.first) : 0).toFixed(0)

        self.then = (self.first ? self.half : self.first).toFixed(0)
        self.then_hr = (self.first ? (self.half / 16) : self.first).toFixed(0)
        let result = self.then_hr 
        self.hasScore = true
        return String(result)
      }
    }
  },
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ER/FluidRepletionAfterBurns.vue